/**
 * These are the styles for the Menu component
 * @param {object} theme - passed by the theme provider
 */
const styles = theme => {
    return {
        errorChip: {
            background: `${theme.palette.error.background} !important`,
            '& svg': {
                color: `${theme.palette.error.main} !important`
            }
        }
    }
}

export default styles
